<template>
  <div>
    <section class="powered_by_sec">
      <img src="@/assets/img/Empire Related logo s.jpg" />
      <!-- New_sponcer_logo.png -->
    </section>
    <div
      class="container px-lg-0 pt-lg-3 custm_heading_margin mobile_custom_margin loyalty_main"
    >
      <div class="cinema-accordion offer-accordion my-4">
        <div v-b-toggle.menu-1 variant="info" class="accordion-title">
          <div class="main-heading">
            <div>
              <hr class="primary-line" />
            </div>
            <div class="title">{{ allLanguageData.Loyalty.howitworks }}</div>

            <!-- <div class="content-desc">
            {{ allLanguageData.Loyalty[1].welcomeTo }}
          </div> -->
            <!-- <div class="sub-titles pl-1">LOCATION</div> -->
          </div>

          <p class="content-title my-3 font-weight-bold">
            {{ allLanguageData.Loyalty.welcomeTo }}
          </p>

          <!-- <p class="content-title my-3">{{ allLanguageData.Loyalty.embark }}</p> -->
          <p
            class="content-title my-3"
            v-html="formatCurrencyText(allLanguageData.Loyalty.embark)"
          ></p>

          <p class="content-title my-3">
            {{ allLanguageData.Loyalty.customerCan }}&nbsp;
            <a
              style="color: #ce1f2e;"
              href="https://apps.apple.com/in/app/empire-cinemas/id1459864736"
              target="_blank"
            >
              {{ allLanguageData.Loyalty.IOS }}
            </a>
            &nbsp;{{ allLanguageData.Loyalty.and }}&nbsp;
            <a
              style="color: #ce1f2e;"
              href="https://play.google.com/store/apps/details?id=com.binary.empirecinema&pli=1"
              target="_blank"
            >
              {{ allLanguageData.Loyalty.Android }}
            </a>

            &nbsp;{{ allLanguageData.Loyalty.users }}
          </p>

          <div class="main-heading">
            <div>
              <hr class="primary-line" />
            </div>
            <div class="title">{{ allLanguageData.Loyalty.getreward }}</div>
          </div>

          <p class="content-title my-3">
            {{ allLanguageData.Loyalty.empireLoyalty }}
          </p>

          <p class="content-title my-3">
            {{ allLanguageData.Loyalty.theprogramconsists }}
          </p>

          <p class="content-title my-3">
            {{ allLanguageData.Loyalty.thecashback }}
          </p>

          <div class="main-heading">
            <div>
              <hr class="primary-line" />
            </div>
            <div class="title">{{ allLanguageData.Loyalty.stampsReward }}</div>
          </div>

          <!-- <p class="content-title my-3">
            {{ allLanguageData.Loyalty.aftersix }}
          </p> -->
          <p
            class="content-title my-3"
            v-html="formatCurrencyText(allLanguageData.Loyalty.aftersix)"
          ></p>

          <p class="content-title my-3">
            {{ allLanguageData.Loyalty.ifyouAre }}
          </p>

          <div
            class="row hiw-cards"
            :class="langName == 'ar' ? 'flex-row-reverse' : ''"
          >
            <!-- card start -->
            <div class="col-12 col-md-4 mb-4">
              <div class="py-4 px-3 px-lg-3 text-center hiw-body h-100">
                <img
                  src="@/assets/img/newImages/Asset4.svg"
                  height="50px"
                  width="50px"
                  alt=""
                />
                <div class="d-block">
                  <div class="hiw-title">
                    {{ allLanguageData.Loyalty.SIGNUPFORFREE }}
                  </div>
                  <span class="mb-0 hiw-text">
                    {{ allLanguageData.Loyalty.get100 }}
                  </span>
                </div>
              </div>
            </div>
            <!-- card end -->
            <div class="col-12 col-md-4 mb-4">
              <div class="py-4 px-3 px-lg-4 text-center hiw-body h-100">
                <img
                  src="@/assets/img/newImages/Asset5.svg"
                  height="75px"
                  width="75px"
                  alt=""
                />
                <div class="d-block">
                  <!-- <div class="hiw-title">
                    {{ allLanguageData.Loyalty.SAR1 }}
                  </div> -->
                  <div
                    class="hiw-title"
                    v-html="formatCurrencyText(allLanguageData.Loyalty.SAR1)"
                  ></div>
                  <!-- <p class="mb-0 hiw-text">

                </p> -->
                </div>
              </div>
            </div>

            <div class="col-12 col-md-4 mb-4">
              <div class="py-4 px-3 px-lg-4 text-center hiw-body h-100">
                <img
                  src="@/assets/img/newImages/new_icon_2_preview.png"
                  class="custom_club_icons"
                  alt=""
                />
                <div class="d-block">
                  <div class="hiw-title">
                    {{ allLanguageData.Loyalty.Stamps_reward }}
                  </div>
                  <!-- <span class="mb-0 hiw-text">
                    {{ allLanguageData.Loyalty.After_six }}
                  </span> -->
                  <span
                    class="mb-0 hiw-text"
                    v-html="
                      formatCurrencyText(allLanguageData.Loyalty.After_six)
                    "
                  ></span>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-4 mb-4">
              <div class="py-4 px-3 px-lg-4 text-center hiw-body h-100">
                <img
                  src="@/assets/img/newImages/Asset6.svg"
                  height="75px"
                  width="75px"
                  alt=""
                />
                <div class="d-block">
                  <div class="hiw-title">
                    {{ allLanguageData.Loyalty.Track_your_points }}
                  </div>
                  <span class="mb-0 hiw-text">
                    {{ allLanguageData.Loyalty.From_our_mobile }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-4 mb-4 ">
              <div class="py-4 px-3 px-lg-4 text-center hiw-body h-100">
                <img
                  src="@/assets/img/newImages/Asset7.svg"
                  height="75px"
                  width="75px"
                  alt=""
                />
                <div class="d-block">
                  <div class="hiw-title">
                    {{ allLanguageData.Loyalty.getDiscount }}
                  </div>
                  <span class="mb-0 hiw-text">
                    {{ allLanguageData.Loyalty.eachLevel }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-4 mb-4">
              <div class="py-4 px-3 px-lg-4 text-center hiw-body h-100">
                <img
                  src="@/assets/img/newImages/new_icon_1_preview.png"
                  class="custom_club_icons_2"
                  alt=""
                />
                <div class="d-block">
                  <div class="hiw-title">
                    {{ allLanguageData.Loyalty.enjoy_event }}
                  </div>
                  <!-- <span class="mb-0 hiw-text">
                  {{ allLanguageData.Loyalty.After_six }}
                </span> -->
                </div>
              </div>
            </div>
          </div>

          <div class="main-heading">
            <div>
              <hr class="primary-line" />
            </div>
            <div class="title">{{ allLanguageData.Loyalty.benefits }}</div>
          </div>
          <!--- Red Loyalty Card Collapse Start-->
          <p class="content-title my-3 font-weight-bold">
            {{ allLanguageData.Loyalty.redCardSubTitle }}
          </p>
          <section class="mb-2">
            <div class="row col-12">
              <div
                class="
              section-title
              btn_red
              my-3
              d-flex
              col-12
              justify-content-between
              section-border section-border
            "
                style="padding:6px;align-items:center;"
                v-b-toggle.RedBenefits
              >
                <div class="pl-3">
                  {{ allLanguageData.Loyalty.redtext }}
                </div>
                <button type="button" class="btn-transparent chevron">
                  <img
                    src="@/assets/img/svg/chevron-down.svg"
                    height="24"
                    width="24"
                  />
                </button>
              </div>
            </div>

            <b-collapse id="RedBenefits" v-model="sectionCollapse.RedBenefits">
              <!-- <p>&#10003;&nbsp;{{ allLanguageData.Loyalty.onePoint }}</p> -->
              <p v-html="formattedOnePointText"></p>
              <p>&#10003;&nbsp;{{ allLanguageData.Loyalty.headsUp }}</p>
              <p>&#10003;&nbsp;{{ allLanguageData.Loyalty.doublepoints }}</p>
              <p>&#10003;&nbsp;{{ allLanguageData.Loyalty.threecashback }}</p>
              <p>&#10003;&nbsp;{{ allLanguageData.Loyalty.upgradetogold }}</p>
            </b-collapse>
          </section>

          <!---Red Loyalty Card Collapse End-->

          <!--- Gold Loyalty Card Collapse Start-->
          <p class="content-title mt-5 mb-3 font-weight-bold">
            {{ allLanguageData.Loyalty.goldCardSubTitle }}
          </p>
          <section class="mb-2">
            <div class="row col-12">
              <div
                class="
              section-title
              btn_gold
              my-3
              d-flex
              col-12
              justify-content-between
              section-border section-border
            "
                style="padding:6px;align-items:center;"
                v-b-toggle.GoldBenefits
              >
                <div class="pl-3">
                  {{ allLanguageData.Loyalty.goldtext }}
                </div>
                <button type="button" class="btn-transparent chevron">
                  <img
                    src="@/assets/img/svg/chevron-down.svg"
                    height="24"
                    width="24"
                  />
                </button>
              </div>
            </div>

            <b-collapse
              id="GoldBenefits"
              v-model="sectionCollapse.GoldBenefits"
            >
              <!-- <p>&#10003;&nbsp;{{ allLanguageData.Loyalty.onePoint }}</p> -->
              <p v-html="formattedOnePointText"></p>
              <p>&#10003;&nbsp;{{ allLanguageData.Loyalty.fivecashback }}</p>
              <p>&#10003;&nbsp;{{ allLanguageData.Loyalty.headsUp }}</p>
              <p>
                &#10003;&nbsp;{{ allLanguageData.Loyalty.golddoublepoints }}
              </p>
            </b-collapse>
          </section>
          <!--- Gold Loyalty Card Collapse Start-->

          <!---User Form To Subscribe For Loyalty Start-->
          <LoyaltyForm />
          <!---User Form To Subscribe For Loyalty End-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import LoyaltyForm from "@/components/pages/loyaltyForm.vue";

export default {
  components: {
    LoyaltyForm
  },
  data() {
    return {
      sectionCollapse: {
        RedBenefits: true,
        GoldBenefits: true
      }
    };
  },
  beforeMount() {
    $(document).ready(function() {
      if ($("body").hasClass("rtl-class")) {
        $("p").addClass("text-right");
      } else {
        $("p").removeClass("text-right");
      }
    });
  },
  computed: {
    formattedOnePointText() {
      const text = this.allLanguageData.Loyalty.onePoint;
      const formatted = this.formatCurrencyText(text);
      return "&#10003;&nbsp;" + formatted;
    }
  },
  methods: {
    formatCurrencyText(text) {
      return text.replace(
        /SAR/g,
        '<span class="sar-symbol" style="font-size:16px">&#xe900;</span>'
      );
    }
  }
};
</script>
<style scoped>
.cinema-accordion .title,
.cinema-accordion .sub-titles {
  font-size: 18px;
}

.cinema-accordion .tab-title {
  font-weight: bold;
  font-size: 11px;
  color: #000;
  text-align: center;
  text-transform: uppercase;
}
.cinema-accordion .accordion-title {
  cursor: pointer;
}
.cinema-accordion .tab-img {
  filter: grayscale(1);
}
.cinema-accordion .tab-img:not(:last-child) {
  padding-right: 05px;
}
.cinema-accordion .nav-link.active .tab-img {
  filter: grayscale(0);
}
.cinema-accordion .nav-link.active .tab-title {
  color: #ce1f2e;
}
.cinema-accordion .nav-link {
  padding: 0 0 10px 0;
  border: 1px solid #fff;
}
.cinema-accordion .nav-tabs {
  border-bottom: 1px solid #fff;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
.cinema-accordion .nav-tabs .nav-link.active,
.cinema-accordion .nav-tabs .nav-item.show .nav-link,
.cinema-accordion .nav-tabs .nav-link:hover,
.cinema-accordion .nav-tabs .nav-link:focus {
  border-color: #fff;
}
.cinema-accordion .cine-addr .addr-loc {
  background-color: #e5e6e7;
}
.cinema-accordion .cine-addr .name {
  color: #434345;
  font-weight: bold;
  font-size: 21px;
}
.cinema-accordion .addr-map {
  background-color: #f8f9fa;
}
.cinema-accordion .addr-map .image {
  height: 100%;
  width: 100%;
}
.cinema-accordion .loc-img {
  width: 278px;
}
.cinema-accordion .cine-addr .desc {
  text-align: center;
  font-weight: 600;
  font-size: 13px;
}
.cinema-accordion .cine-addr .addr-btn {
  background-color: #ce1f2e;
  color: #fff;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 13px;
  /* width: 140px; */
  border-radius: 0px;
  /* position: absolute;
  bottom: 05%;
  transform: translate(-50%, -50%); */
}

.cinema-accordion .accordion-title[aria-expanded="true"] .sub-titles {
  color: #ce1f2e;
  font-weight: bold;
}
@media (max-width: 768px) {
  .mobile_custom_margin {
    margin: 12rem 0 3rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LoyaltyHowItWorks.vue